const getPlaceAddressComponents = async (
  prediction: google.maps.places.PlacePrediction,
  language?: string,
): Promise<google.maps.GeocoderAddressComponent[] | null> => {
  const place = prediction.toPlace();
  if (language) place.requestedLanguage = language;
  try {
    // toPlace preserves the autocomplete session for the terminating details request.
    await place.fetchFields({ fields: ['addressComponents'] });
  } catch {
    return null;
  }
  return (
    place.addressComponents?.map(component => ({
      long_name: component.longText ?? '',
      short_name: component.shortText ?? '',
      types: component.types,
    })) ?? null
  );
};

export { getPlaceAddressComponents };
